function titleCase(value) {
    return value
        .split(' ')
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}

function slugTail(slug, prefix) {
    return slug.startsWith(prefix) ? slug.slice(prefix.length) : '';
}

function rxSortValue(value) {
    const match = String(value || '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
}

function formatRxHtml(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return text.replace(/\bRx\b/gi, 'R<span class="rx-x">x</span>');
}

function parseMetaLine(meta) {
    if (!meta) return null;
    const parts = meta.split('•').map((part) => part.trim());
    if (parts.filter(Boolean).length < 2) return null;

    return {
        rx: parts[0] || '',
        director: parts[1] || '',
        orig: parts[2] || '',
        vprx: parts[3] || '',
        qty: parts[4] || '',
    };
}

function parseTags(row) {
    const tags = Array.from(row.querySelectorAll('.rxhistory-tag'));
    const data = { rx: '', director: '', orig: '', vprx: '', qty: '' };

    tags.forEach((tag) => {
        const slug = tag.dataset.slug || '';
        const name = tag.dataset.name || '';

        if (slug.startsWith('hash-rx-')) {
            const num = slugTail(slug, 'hash-rx-');
            data.rx = `RX-${num}`;
        }

        if (slug.startsWith('hash-director-')) {
            const person = titleCase(slugTail(slug, 'hash-director-').replace(/-/g, ' '));
            data.director = `Directed by ${person}`;
        }

        if (slug.startsWith('hash-orig-rx-')) {
            const year = slugTail(slug, 'hash-orig-rx-');
            data.orig = `Orig. Rx ${year}`;
        }

        if (slug.startsWith('hash-vprx-')) {
            const year = slugTail(slug, 'hash-vprx-');
            data.vprx = `VPRx ${year}`;
        }

        if (slug.startsWith('hash-qty-')) {
            const qty = slugTail(slug, 'hash-qty-');
            data.qty = `Qty. ${qty}`;
        }
    });

    return data;
}

function setCell(row, col, text, sortValue) {
    const cell = row.querySelector(`[data-col="${col}"]`);
    if (!cell) return;

    const valueEl = cell.querySelector('.rxhistory-cell-value');
    if (valueEl) {
        if (col === 'orig' || col === 'vprx') {
            valueEl.innerHTML = formatRxHtml(text);
        } else {
            valueEl.textContent = text;
        }
    }

    cell.dataset.sortValue = sortValue ?? text;
}

function populateRow(row) {
    const meta = parseMetaLine(row.dataset.meta);
    const tags = parseTags(row);
    const rx = row.dataset.rx || meta?.rx || tags.rx;
    const film = row.dataset.title || '';
    const director = meta?.director || tags.director;
    const orig = meta?.orig || tags.orig;
    const vprx = meta?.vprx || tags.vprx;
    const qty = meta?.qty || tags.qty;

    setCell(row, 'rx', rx, rxSortValue(rx));
    setCell(row, 'film', film, film.toLowerCase());
    setCell(row, 'director', director, director.replace(/^Directed by\s+/i, '').toLowerCase());
    setCell(row, 'orig', orig, rxSortValue(orig));
    setCell(row, 'vprx', vprx, rxSortValue(vprx));
    setCell(row, 'qty', qty, rxSortValue(qty));
}

function compareValues(a, b, type) {
    const aNum = Number(a);
    const bNum = Number(b);
    const aIsNum = a !== '' && !Number.isNaN(aNum);
    const bIsNum = b !== '' && !Number.isNaN(bNum);

    if (aIsNum && bIsNum) return aNum - bNum;
    return String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true });
}

function sortTable(table, sortKey, direction) {
    const body = table.querySelector('.rxhistory-table-body');
    const rows = Array.from(body.querySelectorAll('.rxhistory-row'));

    rows.sort((left, right) => {
        const a = left.querySelector(`[data-col="${sortKey}"]`)?.dataset.sortValue ?? '';
        const b = right.querySelector(`[data-col="${sortKey}"]`)?.dataset.sortValue ?? '';
        const result = compareValues(a, b);
        return direction === 'asc' ? result : -result;
    });

    rows.forEach((row) => body.appendChild(row));
}

function updateSortButtons(table, activeKey, direction) {
    table.querySelectorAll('.rxhistory-sort').forEach((button) => {
        const isActive = button.dataset.sort === activeKey;
        button.classList.toggle('is-active', isActive);
        button.dataset.direction = isActive ? direction : '';
        button.setAttribute('aria-sort', isActive ? (direction === 'asc' ? 'ascending' : 'descending') : 'none');
    });
}

export default function initRxHistoryTable() {
    const table = document.querySelector('[data-rxhistory-table]');
    if (!table) return;

    table.querySelectorAll('.rxhistory-row').forEach(populateRow);

    table.querySelectorAll('.rxhistory-row').forEach((row) => {
        row.addEventListener('click', (event) => {
            if (event.target.closest('a, button')) return;
            const href = row.dataset.href;
            if (href) window.location.href = href;
        });
    });

    let activeSort = '';
    let activeDirection = 'asc';

    table.querySelectorAll('.rxhistory-sort').forEach((button) => {
        button.addEventListener('click', () => {
            const sortKey = button.dataset.sort;
            if (activeSort === sortKey) {
                activeDirection = activeDirection === 'asc' ? 'desc' : 'asc';
            } else {
                activeSort = sortKey;
                activeDirection = 'asc';
            }

            updateSortButtons(table, activeSort, activeDirection);
            sortTable(table, activeSort, activeDirection);
        });
    });
}
